import * as React from 'react';
import moment = require('moment');
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Formik, FormikProps } from 'formik';
import { FormInput } from 'common/components/form/FormInput';
import { VoucherApi } from 'common/api/resources/Voucher';

import { Loading } from './../Loading';

interface PassFailDialogProps {
  isOpen?: boolean;
  confirmLabel?: string;
  email?: string;
  cancelLabel?: string;
  closeLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  voucher: string;
  isLoading?: boolean;
  loadingMessage?: string;
  error?: string;
  success?: string;
}

interface PassFailDialogValues {
  isPassed?: string;
  examPassFailDate?: string;
  email?: string;
}
interface PassFailDialogState {
  isLoading: boolean;
}
export class PassFailDialog extends React.Component<PassFailDialogProps, PassFailDialogState> {
  state: PassFailDialogState = { isLoading: false };
  initialValues() {
    return {
      isPassed: 'false',
      examPassFailDate: moment().format('L'),
      email: this.props.email ? this.props.email : '',
    };
  }

  handleSubmit = async (values: PassFailDialogValues) => {
    await this.setState({ isLoading: true });
    VoucherApi.updateVoucher(this.props.voucher, {
      isPassed: values.isPassed,
      examPassFailDate: moment(values.examPassFailDate).toISOString(),
      // email: values.email,
    })
      .then(() => {
        this.setState({ isLoading: false });
        this.props.onConfirm();
      })
      .catch(e => {
        this.setState({ isLoading: false });
      });
  };
  render() {
    const props = this.props;
    const { isLoading } = this.state;
    return (
      <Modal size="md" isOpen={props.isOpen} toggle={props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<PassFailDialogValues>) => (
            <form onSubmit={form.handleSubmit}>
              <ModalHeader toggle={props.onCancel}>Mark Pass / Fail</ModalHeader>
              <ModalBody>
                <div className="row">
                  <div className="col">
                    <FormInput id="isPassed" name="isPassed" label="Passed" tag="select" autoComplete="off">
                      <option value="true">Pass</option>
                      <option value="false">Fail</option>
                    </FormInput>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <FormInput
                      label="Exam Date"
                      type="date"
                      name="examPassFailDate"
                      id="examPassFailDate"
                      defaultValue={moment().format('L')}
                    />
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                {!props.success && (
                  <div>
                    <Button
                      disabled={isLoading}
                      color="secondary"
                      onClick={props.onCancel}
                      data-testid="PassFailDialogSecondaryAction"
                    >
                      {props.cancelLabel ? props.cancelLabel : 'Cancel'}
                    </Button>{' '}
                    <Button
                      disabled={isLoading}
                      color="primary"
                      type="submit"
                      data-testid="PassFailDialogPrimaryAction"
                    >
                      {props.confirmLabel ? props.confirmLabel : 'Confirm'}
                    </Button>
                  </div>
                )}
                {props.success && (
                  <Button
                    color="primary"
                    disabled={isLoading}
                    onClick={props.onCancel}
                    data-testid="PassFailDialogPrimaryAction"
                  >
                    {props.closeLabel ? props.closeLabel : 'Close'}
                  </Button>
                )}
              </ModalFooter>
              {props.error && (
                <div className="alert alert-danger" style={{ margin: 10 }}>
                  {props.error}
                </div>
              )}
              {props.success && (
                <div className="alert alert-success" style={{ margin: 10 }}>
                  {props.success}
                </div>
              )}
              {isLoading && (
                <div style={{ margin: 10 }}>
                  <Loading message={props.loadingMessage} />
                </div>
              )}
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dialogs/PassFailDialog.tsx